import {DisplayContext as DateRangeDisplayContext} from 'common/widgets/date-range-picker/models/types';
import {ResourceType} from 'common/report/constants';
import {findKeyByValue} from 'common/util/typescript';

import {CohortsPropertyFilter} from './cohorts-property-filter';
import {DefaultPropertyFilter} from './default-property-filter';
import {PropertyFilter} from './property-filter';
import {CustomEventPropertyFilter} from './segfilter';
import {DisplayContext, NthTimeOperator, PropertyType} from './types';

export {STRING_TYPECAST_PROPERTIES} from './../../../report/constants';

export function createPropertyFilter(
  attributes: Partial<PropertyFilter>,
  {displayContext}: {displayContext: DisplayContext},
): PropertyFilter {
  const PropertyFilterClass = {
    [DisplayContext.Cohorts]: CohortsPropertyFilter,
    [DisplayContext.CustomEvent]: CustomEventPropertyFilter,
    [DisplayContext.Default]: DefaultPropertyFilter,
    [DisplayContext.Insights]: DefaultPropertyFilter,
    [DisplayContext.Signal]: PropertyFilter,
  }[displayContext];
  return new PropertyFilterClass(attributes);
}

export const DATE_RANGE_DISPLAY_CONTEXT_MAP: {[k in DisplayContext]: DateRangeDisplayContext} = {
  [DisplayContext.Cohorts]: DateRangeDisplayContext.Default,
  [DisplayContext.CustomEvent]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Insights]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Default]: DateRangeDisplayContext.PropertyFilter,
  [DisplayContext.Signal]: DateRangeDisplayContext.Default,
};

export class PropertyFilterFactory {
  public static createPropertyFilter(
    attributes: Partial<PropertyFilter>,
    {displayContext}: {displayContext: DisplayContext},
  ): PropertyFilter {
    return createPropertyFilter(attributes, {displayContext});
  }
}

/**
 * Creates a default first time filter
 * @param displayContext DisplayContext
 */
export function createFirstTimeEventFilter({
  displayContext = DisplayContext.Default,
}: {
  displayContext?: DisplayContext;
} = {}) {
  return createPropertyFilter(
    {
      propertyType: PropertyType.NonProperty,
      propertyDefaultType: PropertyType.NonProperty,
      filterOperator: NthTimeOperator.FirstTime,
      resourceType: ResourceType.Event,
      propertyName: `$nth_time_event`,
    },
    {displayContext},
  );
}

export function isFirstTimeEventFilter(filter: PropertyFilter) {
  return filter.resourceType === ResourceType.Event && Boolean(findKeyByValue(NthTimeOperator, filter.filterOperator));
}
